<template>
  <section class="CategoriesList" >
    <div class="CategoriesList__grid">
      <div v-for="(row, index) in data.categories" :key="index"
        :class="{ 'CategoriesList__full': isOdd && index === data.categories.length - 1 }">
        <SingleCategoryCard
          :image="row.category && row.category.acf && row.category.acf.category_image ? row.category.acf.category_image.url : ''"
          :title="row.category.name"
          link_label='View Collection'
          :link_url="`/product-type/${row.category.slug}`"
          :description="row.category.description"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import SingleCategoryCard from '@/components/utility/SingleCategoryCard.vue'
const props = defineProps(['data'])
const isOdd = computed(() => props.data.categories && props.data.categories.length % 2 !== 0)
</script>

<style lang="scss" scoped>
  .CategoriesList{
    @apply px-[10px] md:px-[18px] lg:px-[14px];
    &__grid{
      @apply grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6;
    }
    &__full{
      @apply md:col-span-2;
    }
  }
</style>
